import { useState } from "react";
import { Pause, Play } from "lucide-react";

/**
 * Auto-scrolling capability ticker.
 *
 * Moving content needs a way to stop it: this pauses on hover, on keyboard
 * focus anywhere inside, and via an explicit control, and it does not animate
 * at all under `prefers-reduced-motion` (where it becomes a scrollable strip).
 * The track is duplicated so the -50% translate loops seamlessly; the copy is
 * hidden from the accessibility tree to avoid the content being read twice.
 */
function Marquee({ items }) {
  const [paused, setPaused] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [focused, setFocused] = useState(false);

  const stopped = paused || hovered || focused;

  const group = (duplicate) => (
    <div className="marquee__group" aria-hidden={duplicate ? "true" : undefined}>
      {items.map((item) => (
        <span className="marquee__item" key={`${duplicate ? "dup" : "src"}-${item.label}`}>
          {item.icon}
          {item.label}
          <span className="marquee__sep" aria-hidden="true">
            /
          </span>
        </span>
      ))}
    </div>
  );

  return (
    <div
      className="marquee"
      data-paused={stopped}
      onPointerEnter={() => setHovered(true)}
      onPointerLeave={() => setHovered(false)}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
    >
      <div className="marquee__track">
        {group(false)}
        {group(true)}
      </div>
      <button
        type="button"
        className="marquee__pause"
        onClick={() => setPaused((p) => !p)}
        aria-label={paused ? "Resume the scrolling capability list" : "Pause the scrolling capability list"}
      >
        {paused ? <Play size={13} aria-hidden="true" /> : <Pause size={13} aria-hidden="true" />}
      </button>
    </div>
  );
}

export default Marquee;
